<div class="{$$props.class} w-full h-0 border border-neutral-800 border-opacity-5" />
